/**
 * AI Search assistant branding.
 * Continuum brand emblem extracted from src/svg/continuum-logo-dark.svg.
 */
export const AI_ICON = '/images/continuum_ai_icon.svg';

/**
 * Ask My Brand mark, used on the FAB. Full-colour on transparency at 575x500,
 * so it wants a light ground and its own aspect ratio kept.
 */
export const AI_FAB_ICON = '/images/ask_my_brand_icon.webp';
